import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
import { selectCleverlynk } from "../../redux/slices/cleverlynkSlice";
import { useSelector } from "react-redux";

import { useTranslation } from "react-i18next";
import "../../i18n/config";

interface NoCoverageDialogProps {
  open: boolean;
  cancel: () => void;
}

function NoCoverageDialog(props: NoCoverageDialogProps) {
  const { t } = useTranslation("deliveryinput");

  const cleverlynk = useSelector(selectCleverlynk);

  const companyPhone = cleverlynk?.company?.phones ? cleverlynk?.company?.phones[0] : undefined;
  return (
    <Dialog open={props.open} onClose={() => props.cancel()}>
      <DialogTitle>{t("noCoverageDialog.coverage0")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("noCoverageDialog.coverage1") +
            (companyPhone ? t("noCoverageDialog.coverage2") + companyPhone + t("noCoverageDialog.coverage3") : "")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.cancel()} color="primary">
          {t("noCoverageDialog.cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NoCoverageDialog;
